import { z } from "zod";

const RateSchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    rate: z.string().regex(/^\d+(\.\d{1,2})?$/, "Invalid rate format"),
});

export const ShowRateResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        rates: z.array(RateSchema),
        total_rate: z.number(),
    }),
});

export type ShowRateResponseType = z.infer<typeof ShowRateResponse>;
export type RateType = z.infer<typeof RateSchema>;